export default __webpack_public_path__ + "static/media/Folder.603eaf79.svg";